import React, { FC } from 'react';
import { RouteComponentProps, Switch, Redirect } from 'react-router-dom';
import { NOT_FOUND_ERROR_PAGE_PATH } from 'src/app/common/constants';
import PruRoute from 'src/app/common/components/PruRoute';
import ParamsProvider from 'src/app/common/components/ParamsProvider';
import { CRITERIA_PATH, SIMULATION_TOOL_PATH } from '../../constants';
import CriteriaSettingListingPage, { criteriaFilterKeys } from './List/CriteriaSettingListingPage';
import CriteriaSettingDetailPage from './Create/CriteriaSettingDetailPage';

const CriteriaManagementPage: FC<RouteComponentProps> = ({ history }) => {
  return (
    <Switch>
      <Redirect
        exact
        from={`${SIMULATION_TOOL_PATH}${CRITERIA_PATH}`}
        to={`${SIMULATION_TOOL_PATH}${CRITERIA_PATH}/list`}
      />
      <PruRoute
        exact
        path={`${SIMULATION_TOOL_PATH}${CRITERIA_PATH}/list`}
        render={(props) => (
          <ParamsProvider {...props} acceptKeys={criteriaFilterKeys}>
            <CriteriaSettingListingPage />
          </ParamsProvider>
        )}
      />
      <PruRoute exact path={`${SIMULATION_TOOL_PATH}${CRITERIA_PATH}/edit/:id`} component={CriteriaSettingDetailPage} />
      <PruRoute exact path={`${SIMULATION_TOOL_PATH}${CRITERIA_PATH}/create`} component={CriteriaSettingDetailPage} />
      <Redirect to={NOT_FOUND_ERROR_PAGE_PATH} />
    </Switch>
  );
};

export default CriteriaManagementPage;
